import React, { memo } from "react";
import PT from "prop-types";
import { useInfiniteQuery } from "react-query";
import { ClientsAPI } from "@/api/clients";
import TaskItem from "_c/modules/tasks/TaskItem";
import last from "lodash/last";
import InfiniteScrollList from "_c/InfiniteScrollList";
import isempty from "lodash/isEmpty";
import Empty from "_c/Empty";
import { TasksCacheService } from "@/services/tasks/cache";
import { useTaskEditor } from "@/hooks/useTaskEditor";

const PER_PAGE = 10;
const ClientTasksHistory = ({ client, t }) => {
  const loadTasks = async ({ pageParam }) => {
    const res = await ClientsAPI.getTasksHistory(client._id, {
      last: pageParam,
      limit: PER_PAGE,
    });
    return res.data;
  };
  const query = useInfiniteQuery(
    TasksCacheService.buildClientHistoryQueryKey(client._id),
    loadTasks,
    {
      staleTime: 0,
      enabled: !!client,
      getNextPageParam: (lastPage) => {
        return last(lastPage)?.start_date;
      },
    },
  );
  const openTaskEditor = useTaskEditor();
  const renderPages = (pages) => {
    if (isempty(pages?.[0])) {
      return <Empty message={t("common:empty")} />;
    }
    return pages.map((page) =>
      page.map((task) => (
        <TaskItem
          viewMode="client"
          task={task}
          t={t}
          key={task._id}
          openEditor={(task) => {
            openTaskEditor({
              task,
              mode: task?.custom ? "custom" : "normal",
              currency: task?.services?.[0]?.final_price?.currency,
              masterId: task.master,
            });
          }}
          css={`
            margin-bottom: 10px;
          `}
        />
      )),
    );
  };
  return <InfiniteScrollList query={query}>{renderPages}</InfiniteScrollList>;
};
ClientTasksHistory.propTypes = {
  client: PT.object,

  t: PT.func.isRequired,
};
export default memo(ClientTasksHistory);
